import { forwardRef } from 'react';
import { Button, ButtonProps, createPolymorphicComponent } from '@mantine/core';
import styles from '@/PageComponents/Onboarding/components/OnboardingButtons.module.css';

/** The onboarding designs' "Primary button": solid blue, 3px corners. */
export const PrimaryButton = createPolymorphicComponent<'button', ButtonProps>(
    forwardRef<HTMLButtonElement, ButtonProps>(({ className, ...props }, ref) => (
        <Button ref={ref} radius={3} className={`${styles.primary} ${className ?? ''}`} {...props} />
    )),
);

type SecondaryProps = ButtonProps & {
    /** The grey "after action" variant, for steps already done. */
    muted?: boolean;
};

/** The onboarding designs' "Secondary button": navy outline, 3px corners. */
export const SecondaryButton = createPolymorphicComponent<'button', SecondaryProps>(
    forwardRef<HTMLButtonElement, SecondaryProps>(({ className, muted, ...props }, ref) => (
        <Button
            ref={ref}
            variant="outline"
            color={muted ? '#4d5b7e' : '#001c89'}
            radius={3}
            className={`${styles.secondary} ${className ?? ''}`}
            {...props}
        />
    )),
);
